import { PharmacyListTabTypes } from '../../../../helpers/Constants';
import strings from '../../../../localization';

type HandleTabClick = (tab: PharmacyListTabTypes) => void;

export const tabConfig = (handleTabClick: HandleTabClick) =>
  [
    {
      key: PharmacyListTabTypes.activePharmacies,
      tabName: strings.activePharmacies,
      onClick: handleTabClick,
    },
    {
      key: PharmacyListTabTypes.myAccounts,
      isDefault: true,
      tabName: strings.myAccounts,
      onClick: handleTabClick,
    },
    {
      key: PharmacyListTabTypes.deactivatedPharmacies,
      tabName: strings.deactivatedPharmacies,
      onClick: handleTabClick,
    },
    {
      key: PharmacyListTabTypes.appointedPharmacies,
      tabName: strings.appointedPharmacies,
      onClick: handleTabClick,
    },
    {
      key: PharmacyListTabTypes.deletedPharmacies,
      tabName: strings.userDeletedAccounts,
      onClick: handleTabClick,
    },
  ];
